const SectionEyebrow = ({ children }) => (
  <div className="flex items-center gap-3">
    <span className="h-px w-10 bg-[#0B3D91]" />
    <span className="label-eyebrow">{children}</span>
  </div>
);

export default SectionEyebrow;
